import { render } from "./CompanyAddActionsButton.vue?vue&type=template&id=57a8a27b&ts=true"
import script from "./CompanyAddActionsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyAddActionsButton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Navigation/CompanyAddActionsButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57a8a27b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57a8a27b', __exports__)) {
    console.log('reload')
    api.reload('57a8a27b', __exports__)
  }
  
  module.hot.accept("./CompanyAddActionsButton.vue?vue&type=template&id=57a8a27b&ts=true", () => {
    console.log('re-render')
    api.rerender('57a8a27b', render)
  })

}


export default __exports__